import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Monotonic counter → unique class per instance so we can scope CSS overrides
// without leaking to other ReactQuill renders on the page.
let __roQuillCounter = 0;

/**
 * ReadOnlyQuill
 * @param {object}   props
 * @param {string}   props.value         HTML from Quill
 * @param {string}  [props.fontSize="12px"]  font-size for the rendered body
 * @param {string}  [props.padding="0"]      .ql-editor padding override
 * @param {string}  [props.color="#555"]     body text colour
 */
const ReadOnlyQuill = ({ value, fontSize = '12px', padding = '0', color = '#555' }) => {
    const quillRef = useRef(null);
    const scopeRef = useRef(null);
    if (scopeRef.current == null) scopeRef.current = `ro-quill-${++__roQuillCounter}`;
    const scope = scopeRef.current;

    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            editor.disable();
            editor.root.innerHTML = value;
        }
    }, [value]);

    return (
        <div className={scope} style={{ fontSize }}>
            <style>{`
                .${scope} .ql-editor {
                    font-size: ${fontSize};
                    padding: ${padding};
                    color: ${color};
                    line-height: 1.4;
                }
                .${scope} .ql-editor p,
                .${scope} .ql-editor li,
                .${scope} .ql-editor span {
                    font-size: ${fontSize};
                }
            `}</style>
            <ReactQuill
                ref={quillRef}
                readOnly={true}
                theme="bubble"
                modules={{ toolbar: false }}
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default ReadOnlyQuill;